import React from "react"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { PageHero } from "../components/programmatic/PageHero"
import { ContentSections } from "../components/programmatic/ContentSections"
import { FAQBlock } from "../components/programmatic/FAQBlock"
import { ServiceCTA } from "../components/programmatic/ServiceCTA"
import { RelatedLinks } from "../components/programmatic/RelatedLinks"
import { Breadcrumbs } from "../components/programmatic/Breadcrumbs"
import { AuthorBox } from "../components/programmatic/AuthorBox"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"
import { buildFaqPage } from "../components/SEO/schema/faqPage"
import { buildBreadcrumbList } from "../components/SEO/schema/breadcrumbList"
import { buildArticle } from "../components/SEO/schema/article"
import type { GlossaryEntry } from "../data/types"

type Props = {
  pageContext: GlossaryEntry
}

const GlossaryTemplate = ({ pageContext }: Props) => {
  const path = `/glossario/${pageContext.slug}`
  const crumbs = [
    { name: "Início", to: "/" },
    { name: "Glossário", to: "/glossario" },
    { name: pageContext.term, to: path },
  ]

  const jsonLd = [
    buildLocalBusiness(),
    buildArticle({
      headline: `O que é ${pageContext.term}?`,
      description: pageContext.metaDescription,
      url: path,
    }),
    buildFaqPage(pageContext.faq),
    buildBreadcrumbList(crumbs),
  ]

  return (
    <Layout>
      <SEO
        title={pageContext.metaTitle}
        description={pageContext.metaDescription}
        canonicalPath={path}
        jsonLd={jsonLd}
      />
      <Breadcrumbs crumbs={crumbs} />
      <PageHero
        eyebrow="Glossário"
        headline={`O que é ${pageContext.term}?`}
        intro={pageContext.shortDefinition}
      />
      <ContentSections sections={pageContext.sections} />
      <FAQBlock faq={pageContext.faq} />
      <ServiceCTA prefill={pageContext.ctaPrefill} />
      <RelatedLinks links={pageContext.related} />
      <AuthorBox />
    </Layout>
  )
}

export default GlossaryTemplate
